import React, { useState, useEffect } from 'react';

import { getModels, getModelsSearch, getModelsSort, getLatestModels, getModelStatsSearch, getDownloadLink } from '../utils/api';
import { useNavigate } from 'react-router-dom';
import ModelDetailDropDown from './DropDownStructure';
import FilterModal from './FilterModal';
import RenderModels from './RenderModels';

const ModelUnit = () => {
  const [models, setModels] = useState([]);
  const [latestModels, setLatestModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [latestLoading, setLatestLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [pendingSearchTerm, setPendingSearchTerm] = useState(''); // For typing the search term without triggering an API call
  const [stats, setStats] = useState({ total: 0, men: 0, women: 0, kids: 0 }); // State for model stats
  const [isModalOpen, setIsModalOpen] = useState(false); // State to track if the modal is open
  const [sortBy, setSortBy] = useState('date');
  const [filterByCategories, setfilterByCategories] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [thumbnails, setThumbnails] = useState({});
  const [isTyping, setIsTyping] = useState(false); // Tracks if the user is typing in the page field
  const [typedPage, setTypedPage] = useState('');
  const pageSize = 24;
  const poolId = 'puma'; // Example, replace with actual poolId if available

  useEffect(() => {
    if (filterApplied) {
      fetchModelsSort();
    }
    if (searchTerm) {
      fetchModelsSearch(); // Use search API when searchTerm is present
      fetchModelStats();   // Fetch stats when searchTerm is updated
    } else {
      fetchModels(); // Use normal API when no search term is present
      fetchModelStats();
    }
  }, [page, searchTerm, sortBy, filterByCategories, filterApplied]);

  useEffect(() => {
    fetchLatestModels();
  }, []);

  const fetchModels = async () => {
    try {
      setLoading(true);
      const response = await getModels(page, pageSize);
      console.log('API Response:', response.data);
      setModels(response.data.content || []);
      setTotalPages(response.data.pagination.totalPages);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching models:', err);
      setError('Failed to fetch models');
      setLoading(false);
    }
  };

  const fetchModelsSearch = async () => {
    try {
      setLoading(true);
      const response = await getModelsSearch(page, pageSize, searchTerm);
      console.log('Search API Response:', response.data);
      setModels(response.data.content || []);
      setTotalPages(response.data.pagination.totalPages);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching search results:', err);
      setError('Failed to fetch search results');
      setLoading(false);
    }
  };

  const fetchLatestModels = async () => {
    try {
      setLatestLoading(true);
      const response = await getLatestModels(1, 6);
      console.log('Latest Models Response:', response.data);
      setLatestModels(response.data.content || []);
      setLatestLoading(false);
    } catch (err) {
      console.error('Error fetching latest models:', err);
      setError('Failed to fetch latest models');
      setLatestLoading(false);
    }
  };

  const fetchModelStats = async () => {
    try {
      const response = await getModelStatsSearch(); // Fetch model stats
      console.log('Model Stats Response:', response.data);
      setStats(response.data); // Update stats state with the data from API
    } catch (err) {
      console.error('Error fetching model stats:', err);
      setError('Failed to fetch model stats');
    }
  };
  const fetchModelsSort = async () => {
    try {
      setLoading(true);
      const response = await getModelsSort(page, pageSize, sortBy, filterByCategories); // Fetching models with the selected sort option
      setModels(response.data.content || []);
      setTotalPages(response.data.pagination.totalPages);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch models');
      setLoading(false);
    }
  };

  const navigate = useNavigate();

  const handleModelClick = (modelId) => {
    navigate(`/model/${modelId}`);
  };

  const handlePrevPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleNextPage = () => {
    setPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  const handleSearchChange = (event) => {
    setPendingSearchTerm(event.target.value); // Update the pending search term state for typing
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSearchTerm(pendingSearchTerm); // Only trigger the search when "Enter" is pressed
      setPage(0); // Reset to the first page whenever a search is performed
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleApplyFilters = (selectedSort, selectedCategories) => {
    setFilterApplied(selectedCategories != '' || selectedSort != '');
    setfilterByCategories(selectedCategories);
    setSortBy(selectedSort);
    closeModal(); // Close the modal after applying filters
  };

  const fetchThumbnailUrl = (model) => {
    if (model.smallThumb && model.smallThumb.file) {
      const file = model.largeThumb.file;
      return getDownloadLink(file);
    }
    return ''; // or a default image URL
  };



  useEffect(() => {
    if (models.length > 0) {
      const modelIds = models.map(model => model.id);

    }
  }, [models]);

  useEffect(() => {
    if (latestModels.length > 0) {
      const latestModelIds = latestModels.map(model => model.id);

    }
  }, [latestModels]);

  if (loading || latestLoading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container">
      {/* Search Input */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search..."
          value={pendingSearchTerm} // Controlled by pendingSearchTerm
          onChange={handleSearchChange} // Update pending search term
          onKeyDown={handleSearchKeyPress} // Trigger search only on Enter
        />
        {/* Display Stats */}
        <div className="model-stats">
          <span>(Total: {stats.total}, </span>
          <span>Men: {stats.male}, </span>
          <span>Women: {stats.female}, </span>
          <span>Kids: {stats.kids})</span>
        </div>
      </div>
      <div className="filters-button">
        {/* Filters Button */}
        <button onClick={openModal}>Filters</button>
      </div>
      <FilterModal
        isOpen={isModalOpen}
        closeModal={closeModal}
        handleApplyFilters={handleApplyFilters}
        page={page}
        pageSize={pageSize}
        currentSort={sortBy} // Pass the current sort option to the modal
        currentCategories={filterByCategories}
      />

      {/* Conditionally show Latest Models */}
      {!filterApplied && !searchTerm && (
        <ModelDetailDropDown
          expand={true}
          summary={<h1 className='title'>Latest Models</h1>}
          details={
            <RenderModels models={latestModels}/>
          }
        />
      )}
      {/** here we display filtered or all models, the rendering is outsourced to the 'Rendermodels' Component*/}
      <div className='models-all'>
        <h1 className='title'>{!filterApplied ? searchTerm ? 'Search Results' : 'All Models' : 'Filtered Models'}</h1>
        <RenderModels models={models}/>
        <hr className='fitting-break'></hr>
      </div>
      {totalPages > 1 && (
  <div className="pagination">
    <button onClick={handlePrevPage} disabled={page === 0}>
      Previous
    </button>
    <span>
      Page
      <input
        type="text"
        value={isTyping ? typedPage : page + 1} // Show typed value if editing, else show the correct page
        onChange={(e) => {
          setIsTyping(true); // Mark as typing
          setTypedPage(e.target.value); // Store the typed value
        }}
        onBlur={() => {
          const newPage = parseInt(typedPage);
          if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
            setPage(newPage - 1); // Update to the valid page (convert 1-based to 0-based)
          }
          setIsTyping(false); // End typing mode
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            const newPage = parseInt(typedPage);
            if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
              setPage(newPage - 1); // Update to the valid page
            }
            setIsTyping(false); // End typing mode
          }
        }}
        placeholder="Type page..." // Guide the user
        style={{ width: '50px', textAlign: 'center', margin: '0 10px' }}
      />
      of {totalPages}
    </span>
    <button onClick={handleNextPage} disabled={page === totalPages - 1}>
      Next
    </button>
  </div>
)}



    </div>
  );
};

export default ModelUnit;
